import { render } from "./personalForm.vue?vue&type=template&id=09da9de7&ts=true"
import script from "./personalForm.vue?vue&type=script&lang=ts"
export * from "./personalForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__